import { z } from 'zod';

import i18n from '@/core/i18n';
import { duplicateNameRefinement } from '@/modules/onboarding/common/utils/duplicate-name-refinement';

import { ProjectFields } from '../types';

export const getProjectsSchema = () => {
  return z.object({
    projects: z
      .array(
        z.object({
          [ProjectFields.Id]: z.number().optional(),
          [ProjectFields.Name]: z
            .string()
            .min(1, i18n.t('authenticated.onboarding.projects:validation.name.required')),
          [ProjectFields.ClientId]: z.string().nullable(),
        })
      )
      .superRefine(
        duplicateNameRefinement(
          p => p[ProjectFields.Name],
          ProjectFields.Name,
          i18n.t('authenticated.onboarding.projects:validation.name.duplicate')
        )
      ),
  });
};
